class HistoryCache {
  constructor() {
    this.cacheKey = 'generatorHistoryCache'
    this.cacheDuration = 5 * 60 * 1000 // 5分钟有效期
  }
  
  // 获取缓存
  getCache() {
    try {
      const cached = sessionStorage.getItem(this.cacheKey)
      if (cached) {
        return JSON.parse(cached)
      }
    } catch (e) {
      console.error('读取缓存失败:', e)
    }
    return null
  }
  
  // 保存缓存
  setCache(data) {
    try {
      const cacheData = {
        ...data,
        timestamp: Date.now()
      }
      sessionStorage.setItem(this.cacheKey, JSON.stringify(cacheData))
      console.log('历史数据已缓存')
    } catch (e) {
      console.error('保存缓存失败:', e)
    }
  }
  
  // 检查缓存是否有效
  isCacheValid() {
    const cache = this.getCache()
    if (!cache || !cache.timestamp) return false
    
    const age = Date.now() - cache.timestamp
    return age < this.cacheDuration
  }
  
  // 获取指定模块的历史数据
  getModuleHistory(moduleType) {
    const cache = this.getCache()
    if (!cache || !cache.modules) return null
    
    return cache.modules[moduleType] || null
  }
  
  // 更新指定模块的历史数据
  updateModuleHistory(moduleType, data) {
    try {
      // 过滤掉 base64 格式的数据（太大，会导致缓存失败）
      const filteredData = data.map(item => {
        const newItem = { ...item }
        
        // 检查 imageUrl 是否为 base64
        if (newItem.imageUrl && newItem.imageUrl.startsWith('data:')) {
          console.warn(`跳过 base64 图片缓存: ${item.id}`)
          newItem.imageUrl = null // 不缓存 base64 数据
        }
        
        // 检查 referenceImage 是否为 base64
        if (newItem.referenceImage && newItem.referenceImage.startsWith('data:')) {
          newItem.referenceImage = null // 不缓存 base64 数据
        }
        
        return newItem
      })
      
      const cache = this.getCache() || { modules: {} }
      cache.modules[moduleType] = filteredData
      cache.timestamp = Date.now()
      
      // 检查数据大小
      const cacheSize = JSON.stringify(cache).length
      if (cacheSize > 5 * 1024 * 1024) { // 5MB 限制
        console.warn('缓存数据过大，可能存储失败')
      }
      
      sessionStorage.setItem(this.cacheKey, JSON.stringify(cache))
      console.log(`已更新 ${moduleType} 模块历史缓存`)
    } catch (e) {
      console.error('更新缓存失败:', e)
    }
  }
  
  // 清除缓存
  clearCache() {
    sessionStorage.removeItem(this.cacheKey)
    console.log('历史缓存已清除')
  }
  
  // 从缓存加载所有模块数据
  loadAllModules() {
    const cache = this.getCache()
    if (!cache || !this.isCacheValid()) {
      return null
    }
    
    return {
      image: cache.modules.image || [],
      video: cache.modules.video || [],
      text: cache.modules.text || [],
      timestamp: cache.timestamp
    }
  }
  
  // 缓存中是否已有某模块的数据
  hasModuleData(moduleType) {
    const cache = this.getCache()
    return cache && cache.modules && cache.modules[moduleType] && cache.modules[moduleType].length > 0
  }
}

export default new HistoryCache()
